/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {UsersListWrapper} from './users-list/UsersList'

type Props = {
  className: string
  userType: string
  customerCode: number
}

const InterpretorViewTable: React.FC<Props> = ({className, userType, customerCode}) => {
  return (
    <div className={`card ${className}`} data-testid="users-list-wrapper">
      <UsersListWrapper customerCode={customerCode} userType={userType} />
    </div>
  )
}

export {InterpretorViewTable}
